package com.shadowings.gero.data.lessons.chapter3

import com.shadowings.gero.data.lessons.inlineMeaning
import com.shadowings.gero.data.lessons.DistractorPool
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import com.shadowings.gero.data.lessons.tokenizePhrase
import com.shadowings.gero.domain.model.ExplanationContent
import com.shadowings.gero.domain.model.Faces
import com.shadowings.gero.domain.model.IExplanation
import com.shadowings.gero.domain.model.IQuizContent
import com.shadowings.gero.domain.model.TextTranslationContent
import com.shadowings.gero.domain.model.WordSelectionContent
import com.shadowings.gero.presentation.component.MdCWord
import com.shadowings.gero.presentation.model.Word
import gero.composeapp.generated.resources.Res
import gero.composeapp.generated.resources.exp_content_bisogna_usare_il_contesto_chiediti_n_n_ha_sen
import gero.composeapp.generated.resources.exp_content_ecco_un_elenco_di_tre_elementi_n_falco_pesce_
import gero.composeapp.generated.resources.exp_content_in_egiziano_antico_per_fare_un_elenco_di_sost
import gero.composeapp.generated.resources.exp_content_la_struttura_semplice_n_n_nome_1_nome_2_nome_
import gero.composeapp.generated.resources.exp_content_ma_come_faccio_a_capire_se_due_nomi_in_fila_s
import gero.composeapp.generated.resources.exp_content_ma_cosa_succede_se_accostiamo_vino_e_birra_n_
import gero.composeapp.generated.resources.exp_content_nelle_lezioni_precedenti_abbiamo_visto_il_gen
import gero.composeapp.generated.resources.exp_content_ora_mettiamoci_alla_prova_con_i_quiz
import gero.composeapp.generated.resources.exp_content_ricorda_il_contesto_la_chiave_per_capire_se_s
import gero.composeapp.generated.resources.exp_content_vediamo_la_lista_pane_e_birra_n_naccostiamo_p
import gero.composeapp.generated.resources.exp_content_vino_acqua_n_nil_vino_dell_acqua_non_ha_senso
import gero.composeapp.generated.resources.exp_content_vino_padre_n_nil_vino_del_padre_s_ha_senso_n_
import gero.composeapp.generated.resources.exp_title_come_distinguere
import gero.composeapp.generated.resources.exp_title_esempio_1
import gero.composeapp.generated.resources.exp_title_esempio_2
import gero.composeapp.generated.resources.exp_title_esempio_pratico
import gero.composeapp.generated.resources.exp_title_introduzione
import gero.composeapp.generated.resources.exp_title_lezione_completata
import gero.composeapp.generated.resources.exp_title_liste_di_sostantivi

fun getListeNomiContent(): List<IExplanation> {
    return listOf(
        ExplanationContent(
            title = Res.string.exp_title_introduzione,
            content = Res.string.exp_content_nelle_lezioni_precedenti_abbiamo_visto_il_gen,
            face = Faces.Happy
        ),
        ExplanationContent(
            title = Res.string.exp_title_introduzione,
            content = Res.string.exp_content_ma_cosa_succede_se_accostiamo_vino_e_birra_n_,
            face = Faces.Surprised
        ),
        ExplanationContent(
            title = Res.string.exp_title_liste_di_sostantivi,
            content = Res.string.exp_content_in_egiziano_antico_per_fare_un_elenco_di_sost,
            face = Faces.Idle
        ),
        ExplanationContent(
            title = Res.string.exp_title_liste_di_sostantivi,
            content = Res.string.exp_content_la_struttura_semplice_n_n_nome_1_nome_2_nome_,
            face = Faces.Serious
        ),
        ExplanationContent(
            title = Res.string.exp_title_esempio_1,
            content = Res.string.exp_content_vediamo_la_lista_pane_e_birra_n_naccostiamo_p,
            face = Faces.Happy,
            composable = {
                Box(
                    modifier = Modifier.fillMaxWidth(),
                    contentAlignment = Alignment.Center
                ) {
                    MdCWord(
                        word = "X1:X2-V28-N35:N29-X1:W22",
                        rtl = false,
                        cart = false
                    )
                }
            }
        ),
        ExplanationContent(
            title = Res.string.exp_title_esempio_2,
            content = Res.string.exp_content_ecco_un_elenco_di_tre_elementi_n_falco_pesce_,
            face = Faces.Happy,
            composable = {
                Box(
                    modifier = Modifier.fillMaxWidth(),
                    contentAlignment = Alignment.Center
                ) {
                    MdCWord(
                        word = "D58-M17-V31-G5-D21-G17-K1-W19-M17-G43-E13",
                        rtl = false,
                        cart = false
                    )
                }
            }
        ),
        ExplanationContent(
            title = Res.string.exp_title_come_distinguere,
            content = Res.string.exp_content_ma_come_faccio_a_capire_se_due_nomi_in_fila_s,
            face = Faces.Surprised
        ),
        ExplanationContent(
            title = Res.string.exp_title_come_distinguere,
            content = Res.string.exp_content_bisogna_usare_il_contesto_chiediti_n_n_ha_sen,
            face = Faces.Serious
        ),
        ExplanationContent(
            title = Res.string.exp_title_esempio_pratico,
            content = Res.string.exp_content_vino_acqua_n_nil_vino_dell_acqua_non_ha_senso,
            face = Faces.Happy
        ),
        ExplanationContent(
            title = Res.string.exp_title_esempio_pratico,
            content = Res.string.exp_content_vino_padre_n_nil_vino_del_padre_s_ha_senso_n_,
            face = Faces.Idle
        ),
        ExplanationContent(
            title = Res.string.exp_title_lezione_completata,
            content = Res.string.exp_content_ricorda_il_contesto_la_chiave_per_capire_se_s,
            face = Faces.Perfect
        ),
        ExplanationContent(
            title = Res.string.exp_title_lezione_completata,
            content = Res.string.exp_content_ora_mettiamoci_alla_prova_con_i_quiz,
            face = Faces.Happy
        )
    )
}

/**
 * Generates quiz content for the "Liste di sostantivi" lesson.
 *
 * Quiz types:
 * 1. WordSelectionContent – Given hieroglyphs of 2 or 3 nouns, the student picks
 *    Italian words to build the correct list phrase (e.g. "pane e birra").
 * 2. SingleSelectionContent – "Is this a list or a genitive?" discrimination questions.
 */
fun getListeNomiQuizContent(words: List<Word>, languageCode: String): List<IQuizContent> {
    data class ListQuizData(
        val hieroglyphs: String,
        val correctPhrase: String,
        val allTokens: List<String>,
        val transliteration: String
    )
    val wordMap = words.associateBy { it.id.uppercase() }
    val generatedQuizData = mutableListOf<ListQuizData>()

    // --- Part A: 2-word noun lists (WordSelectionContent) ---
    // Pairs that semantically make sense only as lists (not as genitive)
    val listPairs = listOf(
        listOf("PANE", "BIRRA"),
        listOf("VINO", "ACQUA"),
        listOf("PANE", "ACQUA_LISTA"),
        listOf("BIRRA", "VINO"),
        listOf("GRANO", "PANE"),
        listOf("FALCO", "COBRA"),
        listOf("TORO", "MUCCA"),
        listOf("GATTO", "PESCE"),
        listOf("UOMO", "DONNA"),
        listOf("PADRE", "MADRE"),
        listOf("PANE", "VINO"),
        listOf("INCENSO", "BIRRA"),
        listOf("ALBERO", "GRANO"),
        listOf("PESCE", "UCCELLO"),
    )

    // --- Part B: 3-word noun lists (WordSelectionContent) ---
    val listTriples = listOf(
        listOf("PANE", "BIRRA", "ACQUA_LISTA"),
        listOf("VINO", "PANE", "GRANO"),
        listOf("FALCO", "TORO", "GATTO"),
        listOf("PESCE", "UCCELLO", "COBRA"),
        listOf("PADRE", "MADRE", "DONNA"),
        listOf("UOMO", "DONNA", "SCRIBA"),
        listOf("MUCCA", "TORO", "GATTO"),
        listOf("PANE", "BIRRA", "VINO"),
        listOf("INCENSO", "GRANO", "ACQUA"),
    )

    // Generate quiz data for 2-word lists
    listPairs.shuffled().take(8).forEach { wordIds ->
        val listWords = wordIds.mapNotNull { wordMap[it] }
        if (listWords.size == wordIds.size) {
            val hieroglyphs = listWords.joinToString("-") { it.gardiner }
            val correctPhrase = buildListPhrase(listWords = listWords, languageCode = languageCode)

            val correctTokens = buildListTokens(listWords = listWords, languageCode = languageCode)
            val wrongTokens = generateDistractors(
                allWords = words,
                correctWords = listWords,
                count = 3,
                languageCode = languageCode
            )

            val allTokens = (correctTokens + wrongTokens)
                .filter { it.isNotBlank() }
                .distinct()
                .shuffled()

            generatedQuizData.add(
                ListQuizData(
                    hieroglyphs = hieroglyphs,
                    correctPhrase = correctPhrase,
                    allTokens = allTokens,
                    transliteration = listWords.joinToString(" ") { it.reading }
                )
            )
        }
    }

    // Generate quiz data for 3-word lists
    listTriples.shuffled().take(6).forEach { wordIds ->
        val listWords = wordIds.mapNotNull { wordMap[it] }
        if (listWords.size == wordIds.size) {
            val hieroglyphs = listWords.joinToString("-") { it.gardiner }
            val correctPhrase = buildListPhrase(listWords = listWords, languageCode = languageCode)

            val correctTokens = buildListTokens(listWords = listWords, languageCode = languageCode)
            val wrongTokens = generateDistractors(
                allWords = words,
                correctWords = listWords,
                count = 3,
                languageCode = languageCode
            )

            val allTokens = (correctTokens + wrongTokens)
                .filter { it.isNotBlank() }
                .distinct()
                .shuffled()

            generatedQuizData.add(
                ListQuizData(
                    hieroglyphs = hieroglyphs,
                    correctPhrase = correctPhrase,
                    allTokens = allTokens,
                    transliteration = listWords.joinToString(" ") { it.reading }
                )
            )
        }
    }

    return generatedQuizData.mapIndexed { index, data ->
        if ((index + 1) % 3 == 0) {
            TextTranslationContent(
                hieroglyphs = data.hieroglyphs,
                correctPhrase = data.correctPhrase,
                transliteration = data.transliteration
            )
        } else {
            WordSelectionContent(
                hieroglyphs = data.hieroglyphs,
                correctPhrase = data.correctPhrase,
                words = data.allTokens,
                transliteration = data.transliteration
            )
        }
    }
}

/**
 * Builds an Italian list phrase from a list of words.
 * e.g. [pane, birra] -> "pane e birra"
 * e.g. [pane, birra, acqua] -> "pane, birra e acqua"
 */
internal fun buildListPhrase(listWords: List<Word>, languageCode: String): String {
    val nouns = listWords.map {
        it.inlineMeaning(languageCode, it.getMeaning(languageCode).split(",")[0].trim())
    }
    val conjunction = when (languageCode) {
        "it" -> "e"
        "de" -> "und"
        "es" -> "y"
        "fr" -> "et"
        else -> "and"
    }
    return when (nouns.size) {
        1 -> nouns[0]
        2 -> "${nouns[0]} $conjunction ${nouns[1]}"
        else -> nouns.dropLast(1).joinToString(", ") + " $conjunction " + nouns.last()
    }
}

/**
 * Builds the list of correct tokens for a noun list phrase.
 * e.g. [pane, birra] -> ["pane", "e", "birra"]
 * e.g. [pane, birra, acqua] -> ["pane", ",", "birra", "e", "acqua"]
 */
internal fun buildListTokens(listWords: List<Word>, languageCode: String): List<String> {
    val tokens = mutableListOf<String>()
    listWords.forEachIndexed { index, word ->
        val noun = word.inlineMeaning(languageCode, word.getMeaning(languageCode).split(",")[0].trim())
        tokens.add(noun)
        if (index < listWords.size - 2) {
            // Between items before the last pair: add comma separator
            tokens.add(",")
        } else if (index == listWords.size - 2) {
            when (languageCode) {
                "it" -> tokens.add("e")
                "de" -> tokens.add("und")
                "es" -> tokens.add("y")
                "fr" -> tokens.add("et")
                else -> tokens.add("and")
            }
        }
    }
    return tokens
}

/**
 * Generates distractor tokens from random words not in the correct answer.
 */
private fun generateDistractors(
    allWords: List<Word>,
    correctWords: List<Word>,
    count: Int,
    languageCode: String
): List<String> {
    val correctIds = correctWords.map { it.id }.toSet()
    val otherWords = DistractorPool.words(allWords).filter {
        it.id !in correctIds &&
                !it.getArticolo(languageCode)
                    .isNullOrBlank() && it.getArticolo(languageCode) != "-" &&
                !it.getGenitivo(languageCode).isNullOrBlank() && it.getGenitivo(languageCode) != "-"
    }
    val wrongWords = otherWords.shuffled().take(count)
    // tokenizePhrase splits any multi-word field (a compound vocabulary meaning like
    // "König von Oberägypten", or a multi-word Spanish genitive like "de la") into
    // separate one-word tiles instead of one glued distractor tile.
    val wrongTokens = mutableListOf<String>()
    wrongWords.forEach { ww ->
        ww.getArticolo(languageCode)?.let { if (it != "-") wrongTokens.addAll(tokenizePhrase(it)) }
        val meaning = ww.inlineMeaning(languageCode, ww.getMeaning(languageCode).split(",")[0].trim())
        wrongTokens.addAll(tokenizePhrase(meaning))
        ww.getGenitivo(languageCode)?.let { if (it != "-") wrongTokens.addAll(tokenizePhrase(it)) }
    }
    return wrongTokens
}
